import { render } from "./approveNode.vue?vue&type=template&id=67791ee1&scoped=true"
import script from "./approveNode.vue?vue&type=script&lang=js"
export * from "./approveNode.vue?vue&type=script&lang=js"

import "./approveNode.vue?vue&type=style&index=0&id=67791ee1&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67791ee1"]])

export default __exports__